/**
 * Feature flags for PLATEAU Tokyo rendering experiments.
 * Defaults keep current production behaviour until explicitly enabled.
 */

function envFlag(name: string): boolean {
  try {
    return import.meta.env[name] === 'true';
  } catch {
    return false;
  }
}

function envFlagDefaultTrue(name: string): boolean {
  try {
    const value = import.meta.env[name];
    if (value === 'false') return false;
    return true;
  } catch {
    return true;
  }
}

export const PLATEAU_FEATURES = {
  /** RFC-113 §1.3 — TilesFadePlugin on streamed b3dm tilesets (REPLACE crossfade). */
  lodFade: envFlag('VITE_PLATEAU_LOD_FADE'),
  /** Legacy zoom gate (superseded by stableMountPolicy). */
  detailLayerZoomGate: envFlag('VITE_PLATEAU_DETAIL_ZOOM_GATE'),
  /** Defer roads/furniture/veg until street-level zoom so buildings keep cache budget. */
  stableMountPolicy: envFlagDefaultTrue('VITE_PLATEAU_STABLE_MOUNT'),
  /** ACES tone mapping for city tiles only (point clouds stay NoToneMapping). */
  cityToneMapping: envFlag('VITE_PLATEAU_CITY_TONE_MAPPING'),
} as const;
